module.exports = __webpack_public_path__ + "static/img/173_TO8_1927_og.1ee16b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/173_TO8_1927_og.jpg
// module id = NCye
// module chunks = 0